import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import type { ProjectResponse } from '@xver/apis/v1/sammeln/projects/model';

export const PROJECT_QUERY_KEY = 'apis.v1.sammeln.projects.get';

export function useProjectQuery(projectIdOrName: string) {
    return useQuery<ProjectResponse>({
        queryKey: [PROJECT_QUERY_KEY, projectIdOrName],
        queryFn: () => Endpoints.v1.Sammeln.Projects.getProject(projectIdOrName),
        enabled: !!projectIdOrName,
        staleTime: 0,
        refetchOnMount: 'always',
        refetchOnWindowFocus: 'always',
    });
}
